import { Outlet } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { SiteFooter } from '#app/components/site-footer.tsx'

/** Prescriber decision portal (spec §6.2): tokenised link, no login. */
export default function PrescriberLayout() {
	return (
		<div className="flex min-h-dvh flex-col">
			<main className="container mx-auto max-w-2xl flex-1 px-4 py-8">
				<Outlet />
			</main>
			<SiteFooter />
		</div>
	)
}

export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: () => (
					<div className="flex flex-col items-center gap-3 py-16 text-center">
						<h1 className="text-2xl font-bold">
							This verification link isn't valid
						</h1>
						<p className="text-muted-foreground">
							The link may be incomplete, or this verification has been
							superseded by a newer request. Please use the most recent email,
							or contact Dimple Color support.
						</p>
					</div>
				),
			}}
		/>
	)
}
